import AnalyticsTracker from "./analytics";
import $ from "jquery";

class AnalyticsService {
    constructor(analytics) {
        this.analytics = analytics;
    }

    trackAll () {
        this.#trackProductDetailImpression();
        this.#trackBeginCheckoutSteps();
        this.#trackSubsequentCheckoutSteps();
        this.#trackPurchase();
        this.#trackThePlacedOrderInGoogleAnalyticsForOCIUsers();
        this.#trackMailAndPhoneClick();
        this.#trackByName();
    }

    trackImpression(items) {
        this.analytics.trackImpression(items);
    }

    trackAddShippingInfo(){
        this.analytics.trackAddShippingInfo();
    }

    trackClearCart(items){
        this.analytics.trackClearCart(items);
    }
    trackViewShoppingCart(items){
        this.analytics.trackViewShoppingCart(items);
    }

    trackRemoveFromCart(item){
        this.analytics.trackRemoveFromCart(
            item.id,
            item.name,
            item.quantity,
            item.price,
            item.leadtime,
            item.accountId,
            item.accountType,
        );
    }

    trackAddToCart(item){
        this.analytics.trackAddToCart(
            item.id,
            item.name,
            item.productList,
            null,
            item.quantity,
            item.price,
            item.leadtime,
            item.accountId,
            item.accountType
        );
    }

    trackChangeQuantityToCart(item){
        this.analytics.trackChangeQuantityToCart(
            item.id,
            item.name,
            item.productList,
            null,
            item.quantity,
            item.price,
            item.leadtime,
            item.accountId,
            item.accountType
        );
    }

    trackTelClickRequestArticleInformation(){
        this.analytics.trackTelClickRequestArticleInformation();
    }

    #trackProductDetailImpression() {
        const analytics = this.analytics;
        $('[data-ga-view]').each(function () {
            const $this = $(this);

            if ($this.data('gaactive') == 1) {
                const trackingData = $this.data('gadata');
                analytics.trackImpression(trackingData.items, trackingData.accountId, trackingData.accountType);
            }
        });
    }

    #trackBeginCheckoutSteps(){
        const analytics = this.analytics;
        $('[data-ga-begin-progress]').each(function () {
            const trackingData = $(this).data('gadata');
            analytics.trackBeginCheckout(trackingData.items);
        });
    }

    #trackSubsequentCheckoutSteps(){
        const analytics = this.analytics;
        $('[data-ga-checkout-progress]').each(function () {
            const trackingData = $(this).data('gadata');
            analytics.trackAddPaymentInfo(trackingData.items);
        });
    }

    #trackPurchase() {
        const analytics = this.analytics;
        $('[data-ga-purchase]').each(function () {
            const trackingData = $(this).data('gadata');
            analytics.trackPurchase(trackingData.id, trackingData.total, trackingData.items);
        });
    }

    #trackThePlacedOrderInGoogleAnalyticsForOCIUsers() {
        const analytics = this.analytics;
        $('form[id=place-oci-form] button[type=submit]').on('click', function (e) {
            e.preventDefault();
            const $form = $('form[id=place-oci-form]');
            const trackingData = $form.parent().data('gadata');
            const confirmUrl = $form.data('confirmUrl');

            if (confirmUrl) {
                $.ajax({
                    url: confirmUrl,
                    method: 'POST',
                }).done(function (res) {
                    if (res.success !== undefined && res.success) {
                        if (trackingData !== undefined) {
                            analytics.trackPurchase(trackingData.id, trackingData.total, trackingData.items);
                        }
                        $form.submit();
                    }
                });
            }
        });
    }

    #trackMailAndPhoneClick() {
        const analytics = this.analytics;
        $('.ga-track-mail-or-phone-click a[href*="mailto:"]').on('click', function (e) {
            e.preventDefault();
            const url = String(e.target.href).split(':');
            if (url?.[0] === 'mailto') {
                analytics.trackMailClick();
            }
            location.href = e.target.href;
        });

        $('.ga-track-mail-or-phone-click a[href*="tel:"]').on('click', function (e) {
            e.preventDefault();
            const url = String(e.target.href).split(':');
            if (url?.[0] === 'tel') {
                analytics.trackTelClick();
            }
            location.href = e.target.href;
        });

        $('.ga-track-mail-click a[href*="mailto:"]').on('click', function (e) {
            e.preventDefault();
            analytics.trackMailClick();
            location.href = e.target.href;
        });

        $('.ga-track-telephone-click a[href*="tel:"]').on('click', function (e) {
            e.preventDefault();
            analytics.trackTelClick();
            location.href = e.target.href;
        });

        $('.ga-track-telephone-click-with-this a[href*="tel:"]').on('click', function (e) {
            e.preventDefault();
            analytics.trackTelClick();
            location.href = $(this).attr('href');
        });
    }

    #trackByName() {
        const analytics = this.analytics;
        /**
         * @uses GLOBAL_LIST_TRACKS defined as Global variable
         * into layout resources/views/layouts/master.blade.php
         * into blade component <x-analytics-script-init />
         */
        if (GLOBAL_LIST_TRACKS && this.analytics) {
            const trackList = GLOBAL_LIST_TRACKS || [];
            if (Array.isArray(trackList) && trackList.length) {
                trackList.forEach(trackName => {
                    analytics[trackName]();
                })
            }
        }
    }
}


const analyticsService = new AnalyticsService(new AnalyticsTracker());
export default analyticsService;
